<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Course Webinar</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row dense justify="center">
                <v-btn @click="today = true;upcoming=false;completed=false" class="button">Today</v-btn>
                <v-btn @click="upcoming=true;today=false;completed=false" class="button">Upcoming</v-btn>
                <v-btn @click="upcoming=false;today=false;completed=true" class="button">Completed</v-btn>
            </v-row>
        </v-card>
        <span v-if="today">

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Today's Course Webinar</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row dense justify="center">
                    <v-col sm="4" md="4">
                        <v-autocomplete class="pt-2" clearable rounded outlined dense v-model="search_today"
                            :items="coursewebinar_today" item-text="course_name" label="Search Course" persistent-hint
                            single-line></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" md="6" v-for="w in todaylist" :key="w.wid">
                        <v-card :elevation="4" class="card" fill-height style="margin: 8px; height: 90%; width: 100%;">
                            <v-col cols="12" sm="12" md="12">
                                <center><strong> {{w.course_name}}</strong></center>
                                <hr />
                                <v-row dense justify="center">
                                    <v-chip class="ma-2" color="primary" outlined pill>
                                        <v-icon left>
                                            mdi-clock
                                        </v-icon>
                                        Start Time : {{w.start_time_lw}}
                                    </v-chip>
                                    <!-- <div class="text-center"> -->
                                    <v-chip class="ma-2" color="success" outlined>
                                        <v-icon left>
                                            mdi-calendar
                                        </v-icon>
                                        Date : {{w.startDate}}
                                    </v-chip>
                                    <!-- </div> -->
                                    <v-chip class="ma-2" color="red" outlined>
                                        <v-icon left>
                                            mdi-clock
                                        </v-icon>
                                        End Time :{{w.end_time_lw}}
                                    </v-chip>
                                </v-row>
                                <div class="text-center">
                                    <!-- <img v-if="w.profile_photo_path!=null" class="pt-5"  :src="w.profile_photo_path" style="width: 40px; height: 50px;" alt="logo" />
                                     <v-icon v-else large color="#0f2027">mdi-account-circle</v-icon> -->
                                    <!-- <br>{{w.course_inst_name}} -->
                                    <h4>Title :{{w.title}}</h4>
                                    <h4>Description :</h4>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <div class="text-center">
                                                <p>{{w.description}}</p>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <span v-if="w.file_link!=null">

                                        <a :href="w.file_link" target="_blank">
                                            <v-btn prepend-icon="mdi-check-circle" append-icon="mdi-account-circle">
                                                <v-icon class="mr-2 v-icon-size" color="primary">mdi-video</v-icon>
                                                <template a:prepend>
                                                    <v-icon color="success"></v-icon>
                                                </template>
                                                Video
                                                <template a:append>
                                                    <v-icon color="warning"></v-icon>
                                                </template>
                                            </v-btn>
                                        </a>
                                    </span>
                                </div>
                                <div class="text-center">
                                    <v-btn class="button" @click="markWebinarAttendance(w.wid)"> Join Now </v-btn>
                                </div>
                            </v-col>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </span>
        <span v-if="upcoming">
            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Upcoming Course Webinar</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row dense justify="center">
                    <v-col sm="4" md="4">
                        <v-autocomplete class="pt-2" clearable rounded outlined dense v-model="search_upcoming"
                            :items="coursewebinar_upcoming" item-text="course_name" label="Search Course"
                            persistent-hint single-line></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" md="6" v-for="w in upcominglist" :key="w.wid">
                        <v-card :elevation="4" class="card" fill-height style="margin: 8px; height: 90%;">
                            <v-col cols="12" sm="12" md="12">
                                <center><strong> {{w.course_name}}</strong></center>
                                <hr />
                                <v-row dense justify="center">
                                    <v-chip class="ma-2" color="primary" outlined pill>
                                        <v-icon left>
                                            mdi-clock
                                        </v-icon>
                                        Start Time : {{w.start_time_lw}}
                                    </v-chip>
                                    <!-- <div class="text-center"> -->
                                    <v-chip class="ma-2" color="success" outlined>
                                        <v-icon left>
                                            mdi-calendar
                                        </v-icon>
                                        Date : {{w.startDate}}
                                    </v-chip>
                                    <!-- </div> -->


                                    <v-chip class="ma-2" color="red" outlined>
                                        <v-icon left>
                                            mdi-clock
                                        </v-icon>
                                        End Time :{{w.end_time_lw}}
                                    </v-chip>
                                </v-row>
                                <div class="text-center">
                                    <!-- <img v-if="w.profile_photo_path!=null" class="pt-5"  :src="w.profile_photo_path" style="width: 40px; height: 50px;" alt="logo" />
                                     <v-icon v-else large color="#0f2027">mdi-account-circle</v-icon>
                                     <br>{{w.course_inst_name}} -->
                                    <h4>Title :{{w.title}}</h4>
                                    <h4>Description :</h4>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <div class="text-center">
                                                <p>{{w.description}}</p>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <span v-if="w.file_link!=null">
                                        <a :href="w.file_link" target="_blank">
                                            <v-btn prepend-icon="mdi-check-circle" append-icon="mdi-account-circle">
                                                <v-icon class="mr-2 v-icon-size" color="primary">mdi-video</v-icon>
                                                <template a:prepend>
                                                    <v-icon color="success"></v-icon>
                                                </template>
                                                Video
                                                <template a:append>
                                                    <v-icon color="warning"></v-icon>
                                                </template>
                                            </v-btn>
                                        </a>
                                    </span>
                                </div>
                            </v-col>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </span>
        <span v-if="completed">
            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title> Completed Course Webinar</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row dense justify="center">
                    <v-col sm="4" md="4">
                        <v-autocomplete class="pt-2" clearable rounded outlined dense v-model="search"
                            :items="coursewebinar_completed" item-text="course_name" label="Search Course"
                            persistent-hint single-line></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" md="6" v-for="w in filteredSortSearchList" :key="w.wid">
                        <v-card :elevation="4" class="card" fill-height style="margin: 8px; height: 90%;">
                            <v-col cols="12" sm="12" md="12">
                                <center><strong> {{w.course_name}}</strong></center>
                                <hr />
                                <v-row dense justify="center">
                                    <v-chip class="ma-2" color="primary" outlined pill>
                                        <v-icon left>
                                            mdi-clock
                                        </v-icon>
                                        Start Time : {{w.start_time_lw}}
                                    </v-chip>
                                    <!-- <div class="text-center"> -->
                                    <v-chip class="ma-2" color="success" outlined>
                                        <v-icon left>
                                            mdi-calendar
                                        </v-icon>
                                        Date : {{w.startDate}}
                                    </v-chip>
                                    <!-- </div> -->


                                    <v-chip class="ma-2" color="red" outlined>
                                        <v-icon left>
                                            mdi-clock
                                        </v-icon>
                                        End Time :{{w.end_time_lw}}
                                    </v-chip>
                                </v-row>
                                <div class="text-center">
                                    <!-- <img v-if="w.profile_photo_path!=null" class="pt-5"  :src="w.profile_photo_path" style="width: 40px; height: 50px;" alt="logo" />
                                     <v-icon v-else large color="#0f2027">mdi-account-circle</v-icon>
                                     <br>{{w.course_inst_name}} -->
                                    <h4>Title :{{w.title}}</h4>
                                    <h4>Description :</h4>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <div class="text-center">
                                                <p>{{w.description}}</p>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <span v-if="w.file_link!=null">
                                        <a :href="w.file_link" target="_blank">
                                            <v-btn prepend-icon="mdi-check-circle" append-icon="mdi-account-circle">
                                                <v-icon class="mr-2 v-icon-size" color="primary">mdi-video</v-icon>
                                                <template a:prepend>
                                                    <v-icon color="success"></v-icon>
                                                </template>
                                                Video
                                                <template a:append>
                                                    <v-icon color="warning"></v-icon>
                                                </template>
                                            </v-btn>
                                        </a>
                                    </span>
                                </div>
                            </v-col>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </span>
    </div>
</template>
<script>
    import axios from "axios";
import webinar_tools from "./Webinar-Tools";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            webinar_tools: webinar_tools,
            Breadcrumbs
        },
        data: () => ({
            snackbar_msg: "",
            color: "",
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            snackbar: false,
            learnerprogress: [],
            coursewebinar_today: [],
            coursewebinar_upcoming: [],
            coursewebinar_completed: [],
            today: false,
            upcoming: false,
            completed: false,
            meet_link: null,
            search:null,
            search_upcoming:null,
            search_today:null,
            description:"",
            title:null,
        }),

        mounted() {
            this.onload();
        },
         computed: {
            filteredSortSearchList(){
            function compare(a, b) {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            }
            if (!this.search) return this.coursewebinar_completed.sort(compare);
                return this.coursewebinar_completed.filter(tbdata=>{
              //  alert(tbdata.course_name)
                    return tbdata.course_name.toLowerCase().indexOf(this.search.toLowerCase())>=0       
                })
            },
            todaylist(){
            function compare(a, b) {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            }
            if (!this.search_today) return this.coursewebinar_today.sort(compare);
                return this.coursewebinar_today.filter(tbdata=>{
              //  alert(tbdata.course_name)
                    return tbdata.course_name.toLowerCase().indexOf(this.search_today.toLowerCase())>=0       
                })
            },
            upcominglist(){
            function compare(a, b) {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            }
            if (!this.search_upcoming) return this.coursewebinar_upcoming.sort(compare);
                return this.coursewebinar_upcoming.filter(tbdata=>{
              //  alert(tbdata.course_name)
                    return tbdata.course_name.toLowerCase().indexOf(this.search_upcoming.toLowerCase())>=0       
                })
            }
        }, // end of computed()

        methods: {
            markWebinarAttendance(wid) {
                const data = {
                    wid: wid,
                };
                axios
                    .post("/Webinar/markWebinarAttendance", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            console.log("res.data " + res.data);
                            this.meet_link = res.data.link;
                            // this.meet_link=data.link;
                            // var w = 750;
                            // var h = 500;
                            // var leftOffset = screen.width / 2 - w / 2;
                            // var topOffset = screen.height / 2 - h / 2;
                            // this.dialog = false;
                            // this.link_join_done = true;
                            window.open(this.meet_link, '_blank').focus()
                           // window.open(this.meet_link, '_blank', "left=" + leftOffset + ",top=" + topOffset + ",width=" + w + ",height=" + h + ",resizable,scrollbars=yes");
                        } else if (res.data.status == "NO") {
                            this.showSnackbar("#b71c1c", res.data.smsg);
                        } else if (res.data.status == "no") {
                            this.meet_link = res.data.link;
                            // var w = 750;
                            // var h = 500;
                            // var leftOffset = screen.width / 2 - w / 2;
                            // var topOffset = screen.height / 2 - h / 2;
                            // this.dialog = false;
                            // this.link_join_done = true;
                             window.open(this.meet_link, '_blank').focus()
                           // window.open(this.meet_link, '_blank', "left=" + leftOffset + ",top=" + topOffset + ",width=" + w + ",height=" + h + ",resizable,scrollbars=yes");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/Webinar/getWebinarList")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.coursewebinar_today = res.data.coursewebinar_today;
                            this.coursewebinar_upcoming = res.data.coursewebinar_upcoming;
                            this.coursewebinar_completed = res.data.coursewebinar_completed;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
    };
</script>
<style scoped>
    input[type="date"] {
        width: 100%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    input[type="time"] {
        width: 30%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .video-section {
        padding: 0rem 0rem 0rem 2rem;
    }

    .video-title {
        border: 1px solid #0f2027;
        padding: 0.6rem 1.2rem 0.4rem 1.2rem;
        border-top-right-radius: 20px;
        background: #0f2027;
        border-top-left-radius: 20px;
        color: white;
    }

    .video-panel {
        border: 2px solid #0f2027;
        padding: 1rem;
        margin-top: 1rem;
        text-align: center;
        min-height: 7.5rem;
    }
    /* .card {
       border: #2c3e50 !important;
    }
    .card:hover {
        background: -webkit-linear-gradient(to right, var(--v-brand-base), var(--v-brandLight-base)); 
        background: linear-gradient(to right, var(--v-brand-base), var(--v-brandLight-base)); 
        color: white !important;
        font-weight: bold !important;
        text-align: center;
        box-shadow: 20px 20px 20px grey !important;
        -webkit-transition:  box-shadow  0.3s ease-in !important;
    }
    .link-icon {
        color: white;
    }
    .add-plus-icon:hover {
        color: white;
    }
    linkname {
        color: #2c5364 !important;
    } */
</style>
